import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, Fragment as _Fragment, createElementBlock as _createElementBlock, renderList as _renderList, Teleport as _Teleport, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "priceshow-category__section__header" }
const _hoisted_3 = { class: "priceshow-category__section__calculator-values" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", null, "Deine Postleitzahl", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", null, "Deine Stadt", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", null, "Deine Straße & Hausnummer", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", null, "Dein Verbrauch in kWh", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", null, "Ich bin Geschäftskund:in", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", null, "Ich bin Strom/Gas Kund:in", -1)
const _hoisted_10 = {
  key: 0,
  class: "priceshow-category__section__content__slider"
}
const _hoisted_11 = {
  key: 1,
  class: "priceshow-category__section__content__notice"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "container-fluid" }, " Leider haben wir an der von dir angegebenen Adresse kein Angebot für dich. Für Fragen stehen wir dir jedoch gern zur Verfügung. ", -1)
const _hoisted_13 = [
  _hoisted_12
]

import BaseCalculator from '@/components/BaseCalculator.vue';
import BaseLoader from '@/components/BaseLoader.vue';
import CardSlider from '@/components/CardSlider.vue';
import Expansion from '@/components/Expansion.vue';
import PriceshowInternetConfigModal from '@/components/order/PriceshowInternetConfigModal.vue';
import Section from '@/components/Section.vue';
import ProductCard from '@/components/product/ProductCard.vue';
import BranchInterface from '@/interfaces/BranchInterface';
import CalculatorModelInterface from '@/interfaces/CalculatorModelInterface';
import PriceshowParamsInterface from '@/interfaces/PriceshowParamsInterface';
import {
  onMounted,
  computed,
  watch,
  ref,
  onBeforeUnmount,
  nextTick,
  inject,
  Ref,
} from 'vue';
import {
  useStore,
} from 'vuex';
import {
  useRoute,
  useRouter,
} from 'vue-router';
import { IoProductAPI } from '@/api';
import Product from '@/classes/Product';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faPencil } from '@fortawesome/pro-solid-svg-icons';
import { formatNumber } from '@/helpers';


export default /*#__PURE__*/_defineComponent({
  __name: 'PriceshowCategorySection',
  props: /*#__PURE__*/_mergeModels({
    branch: {},
    sectionProps: {}
  }, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {

library.add(faPencil);

const route = useRoute();
const store = useStore();
const router = useRouter();
const stickyCont = ref();

const props = __props;

const modelValue = _useModel<PriceshowParamsInterface>(__props, "modelValue");
const routeQueryVars = computed(() => route.query);

const priceshow = ref({
  loading: false,
  products: [] as Product[],
});

const isMobileBreakpoint = inject('isMobileBreakpoint') as Ref<boolean>;
const calculatorExpanded = ref<boolean>(!isMobileBreakpoint.value);
const showCalculator = () => {
  calculatorExpanded.value = true;
};

const internetConfigModal = ref<typeof PriceshowInternetConfigModal>();
const productsSorted = ref<Product[]>([]);
const fetchCount = ref(0);

watch(() => priceshow.value.products, () => {
  productsSorted.value = [...priceshow.value.products].sort(($pa, $pb) => {
    if (
      ($pa.isRecommended && !routeQueryVars.value.pid)
        || $pa.id === parseInt(routeQueryVars.value.pid as string, 10)
    ) {
      return -1;
    }

    return $pa.getPriceValue('yearly') < $pb.getPriceValue('yearly') ? 1 : -1;
  });

  fetchCount.value += 1;
});
const fetchPrices = () => {
  priceshow.value.loading = true;

  IoProductAPI.getAllWithPrices({
    ...modelValue.value,
    branch: props.branch.slug,
  }).then((data) => {
    priceshow.value.products = data;
  }).catch(() => {
    priceshow.value.products = [];
  }).finally(() => {
    priceshow.value.loading = false;
  });
};

const calculatorTimeout = ref<any>();
const onCalculatorChange = (formData: CalculatorModelInterface, valid: boolean) => {
  const currentModelValue = { ...modelValue.value } as PriceshowParamsInterface;
  const updatedModelValue: PriceshowParamsInterface = {
    ...currentModelValue,
    customerType: formData.business ? 'business' : 'private',
    isCustomer: !!formData.isCustomer,
    usage: formData.usage as number,
    postcode: formData.postcode as string,
    city: formData.city as string,
    street: formData.street as string,
    houseNumber: formData.houseNumber as string,
  };

  const isDifferentRequest = JSON.stringify(currentModelValue) !== JSON.stringify(updatedModelValue);

  if (valid && isDifferentRequest) {
    if (calculatorTimeout.value) {
      clearTimeout(calculatorTimeout.value);
    }
    calculatorTimeout.value = setTimeout(() => {
      modelValue.value = updatedModelValue;
      calculatorExpanded.value = false;
      nextTick(fetchPrices);
    }, 1500);
  } else if (!valid && calculatorTimeout.value) {
    clearTimeout(calculatorTimeout.value);
  }
};

const showOtherBranchModalProduct = ref<Product | null>(null);

onMounted(() => {
  fetchPrices();
});

const goToOrder = (): void => {
  showOtherBranchModalProduct.value = null;
  priceshow.value.loading = true;
  router.push('/bestellung/adresse/');
};

const cartItemKey = ref(routeQueryVars.value.cik);

const addProductToCart = ($product: Product) => {
  priceshow.value.loading = true;

  store.dispatch('cart/add', {
    product: $product,
    cartItemKey: cartItemKey.value,
    params: modelValue.value,
    entry: true,
  }).then((response) => {
    const responseData = response as {
      cartEnabled: boolean,
    };

    if (responseData.cartEnabled) {
      priceshow.value.loading = false;
      store.commit('cart/SHOW_WIDGET');
    } else {
      goToOrder();
    }
  });
};

const openInternetConfigurationModal = (product: Product) => {
  internetConfigModal.value?.open(product);
};

const onClickOrder = (product: Product) => {
  switch (product.category.key) {
    case 'internet':
      openInternetConfigurationModal(product);
      break;
    default:
      addProductToCart(product);
  }
};

const setStickyTop = () => {
  const header = document.querySelector('header');
  if (stickyCont.value && header) {
    stickyCont.value.style.top = `${header.offsetHeight}px`;
  }
};

onMounted(() => {
  window.addEventListener('resize', setStickyTop);
  window.addEventListener('load', setStickyTop);
  setStickyTop();
});

onBeforeUnmount(() => {
  window.removeEventListener('resize', setStickyTop);
  window.removeEventListener('load', setStickyTop);
});

return (_ctx: any,_cache: any) => {
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!

  return (_openBlock(), _createBlock(Section, _normalizeProps(_guardReactiveProps({
        ..._ctx.sectionProps,
        class: 'priceshow-category__section'
      })), {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", {
              class: _normalizeClass(["priceshow-category__section__header__headline", {
                'is-action': _unref(isMobileBreakpoint)
              }]),
              onClick: showCalculator
            }, [
              _createTextVNode(" Deine Angaben "),
              (_unref(isMobileBreakpoint))
                ? (_openBlock(), _createBlock(_component_FontAwesomeIcon, {
                    key: 0,
                    icon: _unref(faPencil)
                  }, null, 8, ["icon"]))
                : _createCommentVNode("", true)
            ], 2),
            _createElementVNode("div", null, [
              _createVNode(Expansion, {
                expanded: !_unref(isMobileBreakpoint) || calculatorExpanded.value
              }, {
                default: _withCtx(() => [
                  _createVNode(BaseCalculator, {
                    branches: modelValue.value?.branch,
                    options: {
                    branch: _ctx.branch.slug,
                    productId: modelValue.value?.productId,
                    postcode: modelValue.value?.postcode,
                    city: modelValue.value?.city,
                    street: modelValue.value?.street,
                    houseNumber: modelValue.value?.houseNumber,
                    usage: modelValue.value?.usage,
                    business: modelValue.value?.customerType === 'business',
                    isCustomer: !!modelValue.value?.isCustomer
                  },
                    wide: "",
                    "hide-submit": "",
                    callback: onCalculatorChange
                  }, null, 8, ["branches", "options"])
                ]),
                _: 1
              }, 8, ["expanded"]),
              _createVNode(Expansion, {
                expanded: _unref(isMobileBreakpoint) && !calculatorExpanded.value
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, [
                    _hoisted_4,
                    _createElementVNode("div", null, _toDisplayString(modelValue.value?.postcode || '-'), 1),
                    _hoisted_5,
                    _createElementVNode("div", null, _toDisplayString(modelValue.value?.city || '-'), 1),
                    _hoisted_6,
                    _createElementVNode("div", null, _toDisplayString(modelValue.value?.street || '') + " " + _toDisplayString(modelValue.value?.houseNumber), 1),
                    (['power', 'gas'].includes(_ctx.branch?.mainCategory?.key))
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _hoisted_7,
                          _createElementVNode("div", null, _toDisplayString(modelValue.value?.usage ? _unref(formatNumber)(modelValue.value?.usage, 0) : '-'), 1)
                        ], 64))
                      : _createCommentVNode("", true),
                    _hoisted_8,
                    _createElementVNode("div", null, _toDisplayString(modelValue.value?.customerType === 'business' ? 'Ja' : 'Nein'), 1),
                    (['internet'].includes(_ctx.branch?.mainCategory?.key))
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _hoisted_9,
                          _createElementVNode("div", null, _toDisplayString(!!modelValue.value?.isCustomer ? 'Ja' : 'Nein'), 1)
                        ], 64))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              }, 8, ["expanded"])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["priceshow-category__section__content", { loading: priceshow.value.loading }])
      }, [
        (productsSorted.value.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              (_openBlock(), _createBlock(CardSlider, {
                key: `priceshow-slider-${modelValue.value?.branch || 'undef'}-${fetchCount.value}`,
                branch: _ctx.branch,
                arrowsActive: ""
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(productsSorted.value, (product) => {
                    return (_openBlock(), _createBlock(ProductCard, {
                      key: `fetch-${fetchCount.value}-product-${product.id}`,
                      "is-single": productsSorted.value.length === 1,
                      product: product,
                      onOrder: onClickOrder
                    }, null, 8, ["is-single", "product"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["branch"]))
            ]))
          : (!priceshow.value.loading && fetchCount.value > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_13))
            : _createCommentVNode("", true),
        (priceshow.value.loading)
          ? (_openBlock(), _createBlock(BaseLoader, {
              key: 2,
              absolute: "",
              "no-background": "",
              "no-shadow": "",
              color: "#fff"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.branch.mainCategory.key === 'internet' ? 'Verfügbarkeit wird geprüft' : 'Deine Preise werden berechnet'), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ], 2),
      (_ctx.branch.mainCategory.key === 'internet')
        ? (_openBlock(), _createBlock(_Teleport, {
            key: 0,
            to: "body"
          }, [
            _createVNode(PriceshowInternetConfigModal, {
              ref_key: "internetConfigModal",
              ref: internetConfigModal,
              "price-params": modelValue.value
            }, null, 8, ["price-params"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 16))
}
}

})